import React, { useState } from "react";
import { proposeTypeTag, TYPE_TAG_GROUPS, TypeTagGroup } from "../../../services/typeTagApi";

/**
 * "Can't find it?" under the picker: asks for a new tag. It is not usable until a studio admin
 * approves it, and a name that already exists is pointed out instead of added twice.
 */
const TypeTagPropose = () => {
  const [open, setOpen] = useState(false);
  const [group, setGroup] = useState<TypeTagGroup>("WEAVE_TECHNIQUE");
  const [nameEn, setNameEn] = useState("");
  const [nameHi, setNameHi] = useState("");
  const [busy, setBusy] = useState(false);
  const [note, setNote] = useState<{ ok: boolean; text: string } | null>(null);

  const send = async (e: React.FormEvent) => {
    e.preventDefault();
    if (busy || !nameEn.trim()) return;
    setBusy(true);
    const result = await proposeTypeTag({ group, nameEn, nameHi: nameHi.trim() || undefined });
    setBusy(false);
    if (result.ok) {
      setNote({ ok: true, text: `“${nameEn.trim()}” was sent to a studio admin. You can use it once it is approved.` });
      setNameEn("");
      setNameHi("");
      setOpen(false);
    } else {
      setNote({ ok: false, text: result.message });
    }
  };

  return (
    <div className="ps-tags__propose">
      {note ? (
        <p className={`ps-tags__note${note.ok ? "" : " is-error"}`} role={note.ok ? "status" : "alert"}>
          {note.text}
        </p>
      ) : null}
      {open ? (
        <form onSubmit={send} className="ps-tags__form">
          <label>
            Group
            <select className="form-control" value={group} onChange={(e) => setGroup(e.target.value as TypeTagGroup)}>
              {TYPE_TAG_GROUPS.map((g) => (
                <option key={g.group} value={g.group}>
                  {g.label}
                </option>
              ))}
            </select>
          </label>
          <label>
            Name
            <input
              className="form-control"
              value={nameEn}
              maxLength={60}
              placeholder="e.g. Kadiyal border"
              onChange={(e) => setNameEn(e.target.value)}
              required
            />
          </label>
          <label>
            Hindi label (optional)
            <input className="form-control" lang="hi" value={nameHi} maxLength={60} onChange={(e) => setNameHi(e.target.value)} />
          </label>
          <div className="ps-tags__form-actions">
            <button type="submit" className="ps-btn ps-btn--blue ps-btn--sm" disabled={busy || !nameEn.trim()}>
              <span>{busy ? "Sending…" : "Send for approval"}</span>
            </button>
            <button type="button" className="ps-btn ps-btn--line ps-btn--sm" onClick={() => setOpen(false)}>
              <span>Cancel</span>
            </button>
          </div>
        </form>
      ) : (
        <button type="button" className="ps-tags__link" onClick={() => setOpen(true)}>
          Can’t find a tag? Propose a new one
        </button>
      )}
    </div>
  );
};

export default TypeTagPropose;
